var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9767",
    "data-name": "Group 9767",
    transform: "translate(-251 21948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5268",
    "data-name": "Rectangle 5268",
    transform: "translate(251 -21948)",
    fill: "none",
    stroke: "#A1A1B3",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 21,
    height: 21,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_27641",
    "data-name": "Path 27641",
    d: "M15.328,23.889,12.3,20.909a1.062,1.062,0,0,1-.1-1.364.957.957,0,0,1,1.513-.1l2.319,2.324L22.388,15.4A1.009,1.009,0,0,1,23.8,16.817L16.74,23.889a.957.957,0,0,1-1.412,0Z",
    transform: "translate(244.999 -21955.199)",
    fill: "#FFCC00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCheckbox);
export default __webpack_public_path__ + "static/media/filledCheckbox.ea7228ef9cf3a7563c366cf99cc85376.svg";
export { ForwardRef as ReactComponent };